export const profileInfo = {
  history: {
    title: "History of reputation changes",
    img: "./img/profile/chart.png",
    alt: "chart history of reputation changes",
  },
  posts: {
    title: "History of posts",
    img: null,
    alt: "chart history of reputation changes",
  },
  questions: {
    title: "Reputation of questions",
    img: "./img/profile/question.jpg",
    alt: "part interface",
  },
  answers: {
    title: "Comments",
    img: "./img/profile/answer.jpeg",
    alt: "part interface",
  },
  favorites: {
    title: "History of favorites",
    img: null,
  },
  notifications: {
    title: "History of reputation notifications",
    img: null,
  },
  privileges: {
    title: "Privileges",
    img: null,
  },
  comments: {
    title: "Comments",
    img: null,
  },
};

export const profileNav = [
  {
    title: "history of reputation",
    active: true,
    id: "history",
  },
  {
    title: "posts",
    active: false,
    id: "posts",
  },
  {
    title: "questions",
    active: false,
    id: "questions",
  },
  {
    title: "answers",
    active: false,
    id: "answers",
  },
  {
    title: "favorites",
    active: false,
    id: "favorites",
  },
  {
    title: "notifications",
    active: false,
    id: "notifications",
  },
  {
    title: "privileges",
    active: false,
    id: "privileges",
  },
  {
    title: "comments",
    active: false,
    id: "comments",
  },
];
